













import { Vue, Component, Prop } from 'vue-property-decorator';

// ツールチップ込みのactiveかdisableのいずれかの状態を持つアイコン
@Component({
  name: 'GOptionalIcon',
  computed: {},
  methods: {},
})
export default class GDefaultIcon extends Vue {
  @Prop({ default: true }) condition: boolean; // active状態を表示する条件
  @Prop() icon: string; // active,disable共通のアイコン
  @Prop({ default: 24 }) size: number; // アイコンサイズ
  @Prop() color: string; // active時の色
  @Prop({ default: 'bottom' }) placement: string; // active,disable共通のツールチップの表示位置
  @Prop({ default: 200 }) tooltipMaxWidth: number; // active,disable共通のツールチップの最大幅
  @Prop() dataTestid: string; // テストタグ

  mounted() {}

  // acitve iconクリック時の挙動
  handleClick() {
    this.$emit('click');
  }
}
